import { useEffect, useState } from "react";

// Tiny persistence helper for the prototype. Mirrors React's useState API
// (supports functional updates) and quietly syncs to localStorage.
export function useLocalStorage(key, initialValue) {
  const [value, setValue] = useState(() => {
    if (typeof window === "undefined") return initialValue;
    try {
      const item = window.localStorage.getItem(key);
      return item !== null ? JSON.parse(item) : initialValue;
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      /* storage unavailable — ignore for prototype */
    }
  }, [key, value]);

  return [value, setValue];
}
